/**
 * v-permission 디렉티브
 * 역할/권한 기반으로 요소 표시/숨김
 *
 * 사용법:
 *   v-permission="['ADMIN', 'SUPER_ADMIN']"  - 해당 역할 중 하나가 있으면 표시
 *   v-permission:route="'/dashboard'"        - 해당 라우트 권한이 있으면 표시
 */

import { store } from '@/store'

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  },
}

function checkPermission(el, binding) {
  const { value, arg } = binding

  if (arg === 'route') {
    // 라우트 권한 체크
    const permissions = store.getters['auth/permissions']
    const hasPermission = permissions.includes(value)

    if (!hasPermission) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  } else {
    // 역할 체크
    const roles = store.getters['auth/roles']
    const requiredRoles = Array.isArray(value) ? value : [value]
    const hasRole = requiredRoles.some((r) => roles.includes(r))

    if (!hasRole) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  }
}

/**
 * Vue 플러그인으로 등록
 */
export const PermissionPlugin = {
  install(Vue) {
    Vue.directive('permission', {
      inserted(el, binding) {
        checkPermission(el, binding)
      },
      update(el, binding) {
        checkPermission(el, binding)
      },
    })

    // 전역 메서드 추가
    Vue.prototype.$hasRole = function (roleName) {
      const roles = store.getters['auth/roles']
      return roles.includes(roleName)
    }

    Vue.prototype.$hasAnyRole = function (roleNames) {
      const roles = store.getters['auth/roles']
      return roleNames.some((r) => roles.includes(r))
    }

    Vue.prototype.$hasPermission = function (route) {
      const permissions = store.getters['auth/permissions']
      return permissions.includes(route)
    }

    Vue.prototype.$isAdmin = function () {
      return this.$hasAnyRole(['SUPER_ADMIN', 'ADMIN'])
    }

    Vue.prototype.$isSuperAdmin = function () {
      return this.$hasRole('SUPER_ADMIN')
    }
  },
}
